<template>
  <div id="ecommerce-filter" class="container">
    <!-- Header -->
    <EcommerceFilterHeader
      :checkboxesPosition="checkboxesPosition"
      :categorySelection="categorySelection"
      :productType="productType"
    ></EcommerceFilterHeader>

    <!-- Result List -->
    <EcommerceFilterResultList
      :numberOfRows="Number(numberOfRows)"
      :numberOfColumns="Number(numberOfColumns)"
    ></EcommerceFilterResultList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EcommerceFilterHeader from './Header';
import EcommerceFilterResultList from './ResultList';

export default {
  name: 'EcommerceFilter',
  components: {
    EcommerceFilterHeader,
    EcommerceFilterResultList,
  },
  props: {
    numberOfRows: {
      type: [String, Number],
      default: 2,
      validator: (value) => !isNaN(value),
    },
    numberOfColumns: {
      type: [String, Number],
      default: 4,
      validator: (value) => !isNaN(value),
    },
    checkboxesPosition: {
      // This prop doesn't work with productType != null and categorySelection = 'single'
      type: String,
      default: 'right-side',
      validator: (value) => ['right-side', 'below'].includes(value),
    },
    categorySelection: {
      type: String,
      default: 'multiple',
      validator: (value) => ['multiple', 'single'].includes(value),
    },
    productType: {
      type: String,
      validator: (value) => ['adoption', 'wildcard'].includes(value) || !value,
    },
  },
  computed: {
    ...mapState({
      products: (state) => state.ecommerce.products,
    }),
  },
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch('getEcommerceProducts');
    if (this.productType) {
      this.$store.dispatch('updateSelectedProductType', this.productType);
    }
  },
  methods: {},
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  padding: 0 3rem;
}

@media only screen and (max-width: 64em) {
  .container {
    padding: 0 2rem;
  }
}

@media only screen and (max-width: 40em) {
  .container {
    padding: 0 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// EcommerceFilter.vue?8da5e48e